  
    import React from 'react';

    const LoadingPdfSpinner = () => (
      <div className="text-center">
        <i className="fa fa-spinner fa-spin" /> Your pdf content is being loaded...
      </div>
    );

    export default LoadingPdfSpinner;
  
